import type { DataModelDetail } from '../api/dataModelsService';
import { datasetDisplayName } from './datasetDisplayName.ts';
import { semanticViewDisplayNames } from './semanticViewDisplayNames.ts';

/** Resolve compiler-generated relation aliases for display only, never SQL or grouping. */
export function resolveEntityDisplayName(
  name: string,
  labels?: ReadonlyMap<string, string>,
): string | undefined {
  const exact = labels?.get(name);
  if (exact !== undefined) return exact;
  // fact_view_compile_step uses <known relation>__<8 lowercase SHA-1 hex digits>.
  const match = /^(.*)__[0-9a-f]{8}$/.exec(name);
  return match ? labels?.get(match[1]) : undefined;
}

/** Shared read-only projection; matching and navigation still use stored identifiers. */
export function dataModelDisplayNames(model: Pick<DataModelDetail, 'views' | 'datasets'>) {
  const tables = model.datasets.map(({ dataset, aliasName }) => ({
    name: dataset.name,
    aliasName,
    displayName: datasetDisplayName(dataset.name, dataset.schemaJson),
  }));
  const views = semanticViewDisplayNames(model.views, tables);
  const labels = new Map<string, string>();
  for (const table of tables) {
    const label = table.aliasName || table.displayName;
    if (label !== table.name) labels.set(table.name, label);
    if (table.aliasName) labels.set(table.aliasName, table.aliasName);
  }
  // Multi-fact baseTables refer to component views, not physical tables.
  for (const view of views) {
    if (view.title) labels.set(view.name, view.title);
  }
  return { views, labels };
}